import React, { useEffect } from 'react';
import { Grid, Stack } from '@mui/material';
import YourOpenRolesWidget from 'modules/hiring/components/yourOpenRoles/yourOpenRoleWidget';
import CandidatesAwaitingReview from 'modules/hiring/components/candidatesAwaitingReview/candidatesAwaitingReview';
import RecentHiringActivityWidget from 'modules/hiring/components/recentHiringActivity/recentHiringActivityWidget';
import HiringHeader from 'modules/hiring/components/hiringHeader';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setSelectedOpenRequisition } from 'modules/hiring/stateManagement/thunks';

const HiringOverview = () => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSelectedOpenRequisition(null));
  }, [dispatch]);
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{ mb: ({ typography }) => typography.pxToRem(20) }}
      >
        <HiringHeader
          id='candidate-overview-header'
           label={translate('hiring')}
        />
      </Grid>
      <Grid item xs={12}>
        <Stack
          id='hiring-overview-page-container'
          data-testid='hiring-overview-page-container'
          gap='1.25rem'
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Stack sx={{ width: { xs: '100%', sm: '26.25rem' }, gap: '1.25rem' }}>
            <CandidatesAwaitingReview />
            <RecentHiringActivityWidget />
          </Stack>
          <Stack sx={{ flex: 826 }}>
            <YourOpenRolesWidget />
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default HiringOverview;
